import { createRouter, createWebHistory } from 'vue-router'
import NotFound from "@/components/Shared/NotFound.vue"

const routes = [
  {

    path: '/',
    component: () => import("@/views/Home.vue")
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsConditions',
    component: () => import("@/views/TermsConditions.vue")
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import("@/views/PrivacyPolicy.vue")
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    component: () => import("@/views/ContactUs.vue")
  },
  {
    path: '/account-deactivation',
    name: 'AccountDeactivation',
    component: () => import("@/views/AccountDeactivation.vue")
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
